import { AttributionModel } from '@flexible-reports/store/api/metadata/types';

export const getMTAMetricForAttribute = (
  attrId: string,
  complimentaryFieldsMap: Record<string, { complimentaryFields: string[] }>,
  metricAttrModelById: Record<string, string>,
  fieldNamesById: Record<string, string>
): { id: string; name: string } | null => {
  const complimentaryFields = complimentaryFieldsMap[attrId]?.complimentaryFields || [];

  for (const fieldId of complimentaryFields) {
    const attrModel = metricAttrModelById[fieldId];
    if (attrModel === AttributionModel.MULTI_TOUCH || attrModel === AttributionModel.MULTI_TOUCH_LEGACY) {
      return {
        id: fieldId,
        name: fieldNamesById[fieldId] || fieldId
      };
    }
  }

  return null;
};
